import React from 'react';

import type { TippyProps } from '@tippyjs/react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const Tooltip: React.FC<TippyProps> = (props: unknown) => <Tippy delay={200} {...props} />;

export default Tooltip;
